/**
 * These are session cookies set by the RB monolith, which store
 * user settings information for users who aren't yet
 * persisted in the RB database.
 */
export const RB_SESSION_COOKIE = '_rb_session';
export const RB_SESSION_COOKIE_4 = '_rb_session4';

export const ENABLE_LISTS = true;

/**
 * Defined as separate constant, as these are used to aggregate data
 * downstream. Refer to https://redbubble.atlassian.net/browse/GM-432
 * for detail.
 */
export const DOCUMENT_TITLE_404 = '404 Page Not Found | Redbubble';

export const availableLocales = {
  en: {
    name: 'en',
    urlSegment: '',
    fullForm: 'en_US',
  },
  de: {
    name: 'de',
    urlSegment: '/de',
    fullForm: 'de_DE',
  },
  fr: {
    name: 'fr',
    urlSegment: '/fr',
    fullForm: 'fr_FR',
  },
  es: {
    name: 'es',
    urlSegment: '/es',
    fullForm: 'es_ES',
  },
};
